import * as React from "react";

import { Link, useNavigate } from "react-router-dom";
import { RiArrowLeftLine } from "react-icons/ri";

import Textfield from "../../Components/Textfield";
import Radio from "../../Components/Radio";
import Dropzone from "../../Components/Dropzone";
import Select from "../../Components/Select";
import Button from "../../Components/Button";
import Paper from "../../Components/Paper";
import NotFinishedContracts from "../../ListSelect/NotFinishedContracts";

import axiosInstance from "../../Api/Axios";
import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";

import "./InsuranceRequest.scss";

const initialFormState = {
  contract_number: "",
  changement_type: "compagnie_assurance",
  insurance_name: "",
  carte_grise: [],
  quittance_assurance: [],
  equipment_type: "",
  registration_number: "",
  last_registration_number: "",
  first_registration_number: "",
};

const InsuranceRequest = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");

  const navigate = useNavigate();

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const handleChangeField = (val, key) => {
    let errorMessage = "";
    if (key === "changement_type") {
      setValRegister((prev) => ({
        ...prev,
        changement_type: val,
      }));
    } else if (key === "registration_number") {
      const regex = /^[A-Z0-9]+$/;
      if (!regex.test(val)) {
        errorMessage =
          "Veuillez saisir uniquement des lettres majuscules et des chiffres.";
      }
    }
    if (key === "equipment_type") {
      if (val === "1") {
        setValRegister((prev) => ({ ...prev, registration_number: "" }));
      }
      if (val === "2") {
        setValRegister((prev) => ({
          ...prev,
          first_registration_number: "",
          last_registration_number: "",
        }));
      } else {
        setValRegister((prev) => ({
          ...prev,
          first_registration_number: "",
          last_registration_number: "",
          registration_number: "",
        }));
      }
    }

    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: errorMessage,
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  // const handleChangeField = (e, key) => {
  //   setFormErrorMessages((prev) => ({
  //     ...prev,
  //     [key]: "",
  //   }));

  //   setValRegister((prev) => ({
  //     ...prev,
  //     [key]: e.target.value,
  //   }));
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formData = new FormData();
    formData.append("contract_number", valRegister.contract_number);
    formData.append("changement_type", valRegister.changement_type);
    formData.append("registration_number", valRegister.registration_number);
    formData.append("insurance_name", valRegister.insurance_name);
    formData.append("carte_grise", valRegister.carte_grise[0] || []);
    formData.append(
      "quittance_assurance",
      valRegister.quittance_assurance[0] || []
    );
    formData.append("equipment_type", valRegister.equipment_type);
    formData.append(
      "last_registration_number",
      valRegister.last_registration_number
    );
    formData.append(
      "first_registration_number",
      valRegister.first_registration_number
    );
    axiosInstance
      .post(
        `${process.env.REACT_APP_API_URL}/change-insurance-requests`,
        formData
      )
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/list-insurance-requests");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  return (
    <>
      <div className="back-home">
        <Link to="/list-insurance-requests" className="link-back">
          <RiArrowLeftLine />
        </Link>
      </div>
      <h1>Demande de modification d'assurance</h1>
      <h6 class="warning-text">Cette prestation vous sera facturée <strong>201 DT TTC</strong>.<br />Montant à régler au moment de la délivrance de l'attestation de changement d'assurance.</h6>
      <p>Veuillez remplir les champs ci dessous</p>
      <Paper>
        <form className="register-form" onSubmit={handleSubmit} noValidate>
          <div
            className={` mb-2 wrap-radios ${
              formErrorMessages.changement_type ? "error-radio" : ""
            }`}
          >
            <Radio
              label="Changement de compagnie d'assurance"
              id="compagnie_assurance"
              name="changement_type"
              value="compagnie_assurance"
              onChange={(e) => {
                if (e.target.checked)
                  handleChangeField("compagnie_assurance", "changement_type");
              }}
              checked={valRegister.changement_type === "compagnie_assurance"}
            />

            <Radio
              label="Annulation tous risques"
              id="reset_risque"
              name="changement_type"
              value="reset_risque"
              onChange={(e) => {
                if (e.target.checked)
                  handleChangeField("reset_risque", "changement_type");
              }}
              checked={valRegister.changement_type === "reset_risque"}
            />
            {formErrorMessages.changement_type && (
              <div className="text-danger">
                {formErrorMessages.changement_type}
              </div>
            )}
          </div>
          <NotFinishedContracts
            label="Numéro de contrat"
            id="contract_number"
            value={valRegister.contract_number || ""}
            onChange={(e) =>
              handleChangeField(e.target.value, "contract_number")
            }
            required
            hasError={formErrorMessages.contract_number}
            errorMessage={
              <div className="text-danger">
                {formErrorMessages.contract_number}
              </div>
            }
          ></NotFinishedContracts>

          <Select
            label="Type matériel"
            id="equipment_type"
            required
            value={valRegister.equipment_type || ""}
            onChange={(e) =>
              handleChangeField(e.target.value, "equipment_type")
            }
            hasError={formErrorMessages.equipment_type}
            errorMessage={
              <div className="text-danger">
                {formErrorMessages.equipment_type}
              </div>
            }
          >
            <option value="">--</option>
            <option value="1">Matériel Roulant</option>
            <option value="2">Autre</option>
          </Select>

          {valRegister.equipment_type === "1" && (
            <div className="wrap-immatriculation">
              <Textfield
                label="Série"
                name="first_registration_number"
                placeholder="XXX"
                id="first_registration_number"
                value={valRegister.first_registration_number || ""}
                onChange={(e) =>
                  handleChangeField(e.target.value, "first_registration_number")
                }
                maxLength="3"
                pattern="\d{3}"
                type="text"
                required
                hasError={formErrorMessages.first_registration_number}
                errorMessage={
                  <div className="text-danger">
                    {formErrorMessages.first_registration_number}
                  </div>
                }
              />
              <span className="caption-immatriculation">TU تونس</span>
              <Textfield
                label="N°"
                name="last_registration_number"
                placeholder="XXXX"
                id="last_registration_number"
                value={valRegister.last_registration_number || ""}
                onChange={(e) =>
                  handleChangeField(e.target.value, "last_registration_number")
                }
                maxLength="4"
                pattern="\d{4}"
                type="text"
                required
                hasError={formErrorMessages.last_registration_number}
                errorMessage={
                  <div className="text-danger">
                    {formErrorMessages.last_registration_number}
                  </div>
                }
              />
            </div>
          )}

          {valRegister.equipment_type === "2" && (
            <Textfield
              autoComplete="off"
              label="Immatriculation"
              name="registration_number"
              placeholder=""
              size="large"
              id="registration_number"
              value={valRegister.registration_number || ""}
              onChange={(e) =>
                handleChangeField(e.target.value, "registration_number")
              }
              type="text"
              required
              hasError={formErrorMessages.registration_number}
              errorMessage={
                <div className="text-danger">
                  {formErrorMessages.registration_number}
                </div>
              }
            />
          )}

          <Textfield
            autoComplete="off"
            label="Compagnie d'assurance"
            name="insurance_name"
            required
            type="text"
            placeholder="Veuillez insérer votre compagnie d'assurance"
            size="large"
            value={valRegister.insurance_name}
            onChange={(e) =>
              handleChangeField(e.target.value, "insurance_name")
            }
            hasError={formErrorMessages.insurance_name}
            errorMessage={
              formErrorMessages.insurance_name && (
                <div className="text-danger">
                  {formErrorMessages.insurance_name}
                </div>
              )
            }
          />
          <Dropzone
            label="Carte grise"
            name="carte_grise"
            hasError={formErrorMessages.carte_grise}
            errorMessage={
              <div className="text-danger">{formErrorMessages.carte_grise}</div>
            }
            value={valRegister.carte_grise || []}
            onChange={(files) => handleChangeField(files, "carte_grise")}
            required
            accept="image/*,.pdf"
            description={
              <>
                Cette dropzone accepte les fichiers de type
                <b> png, jpg, jpeg, pdf</b>
              </>
            }
          />
          <Dropzone
            label="Quittance de l'assurance"
            name="quittance_assurance"
            hasError={formErrorMessages.quittance_assurance}
            errorMessage={
              <div className="text-danger">
                {formErrorMessages.quittance_assurance}
              </div>
            }
            value={valRegister.quittance_assurance || []}
            onChange={(files) =>
              handleChangeField(files, "quittance_assurance")
            }
            required
            accept="image/*,.pdf"
            description={
              <>
                Cette dropzone accepte les fichiers de type
                <b> png, jpg, jpeg, pdf</b>
              </>
            }
          />

          <div className="wrap_actions_form">
            <Button type="submit" size="lg">
              Envoyer
            </Button>
          </div>
        </form>
      </Paper>
    </>
  );
};

export default InsuranceRequest;
